import React, { useState, useEffect, useCallback } from "react";
import { Link, useHistory } from "react-router-dom";
import { useProductsContext } from "../../../contexts/ProductsContext/ProductsContext";
import Slider from "react-slick";
import prevArrow from "../../../assets/icons/left-cat-arrow.svg";
import nextArrow from "../../../assets/icons/right-cat-arrow.svg";
import { useQuery } from "@apollo/react-hooks";
import { GET_PRODUCTS_MENU } from "../../../queries/categoriesQuery";
import { Container } from "reactstrap";
import "./Categories.scss";

const PrevArrowIcon = ({ currentSlide, slideCount, ...rest }) => <img id="arrow_cat" src={prevArrow} alt="" {...rest} />;
const NextArrowIcon = ({ currentSlide, slideCount, ...rest }) => <img id="arrow_cat" src={nextArrow} alt="" {...rest} />;

export const Categories = (props) => {
  const [sliderStatus, setSliderStatus] = useState("started");
  const { data, error, loading } = useQuery(GET_PRODUCTS_MENU);
  const ProductsCTX = useProductsContext();
  const history = useHistory();

  const menuItems = data?.menus?.nodes?.[0]?.menuItems?.nodes || [];

  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) ProductsCTX.changeActiveCategory();
  }, [ProductsCTX]);

  useEffect(() => {
    history.listen(() => {});
  });

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);
    return () => document.removeEventListener("keydown", escFunction, false);
  }, [escFunction]);

  if (loading) return <div className="Categories d-flex flex-row align-items-center"></div>;
  if (error) return <div className="Categories d-flex flex-row align-items-center">Error!</div>;
  if (!data?.menus) return <div className="Categories d-flex flex-row align-items-center">Nuk ka kategori!</div>;
  const settings = {
    dots: false, infinite: false, speed: 600, slidesToScroll: 1, slidesToShow: 5, swipe: false,
    responsive: [
      { breakpoint: 1200, settings: { slidesToScroll: 1, slidesToShow: 3, swipe: true } },
      { breakpoint: 800, settings: { slidesToScroll: 1, slidesToShow: 4, swipe: true } },
      { breakpoint: 500, settings: { slidesToShow: 2, slidesToScroll: 1, swipe: true } },
    ],
    variableWidth: true, nextArrow: <NextArrowIcon />, prevArrow: <PrevArrowIcon />,
    afterChange: (index) => {
      if (index > 0) { setSliderStatus("slided"); document.getElementById("cat-slider").classList.add("slided"); }
      if (index === 0) { setSliderStatus("started"); document.getElementById("cat-slider").classList.add("started"); document.getElementById("cat-slider").classList.remove("finished"); document.getElementById("cat-slider").classList.remove("slided"); }
      if (index === menuItems.length) { document.getElementById("cat-slider").classList.add("finished"); document.getElementById("cat-slider").classList.remove("started"); }
    },
  };

  const subItems = menuItems.filter((item) => item.childItems?.nodes?.length > 0).map((item) => ({
    id: item.connectedObject?.productCategoryId,
    list: item.childItems.nodes,
  }));

  const handleCategoryClick = (id, categoryName) => {
    const subCategories = subItems.filter((item) => item.id === id);
    if (subCategories.length > 0) { ProductsCTX.handleCategoryChange(id); }
    else { ProductsCTX.filterProductsWithCategory(id, categoryName); }
  };

  const handleSubCategoryClick = (slug) => {
    ProductsCTX.handleSubCategoryChange(slug);
    history.push(`/kategoria/${slug}`);
  };

  if (history.location.pathname.includes("informacione")) return null;

  return (
    <>
      <div className="Categories" id="cat-slider" data-active-category={ProductsCTX.activeCategoryId}>
        <span className={sliderStatus === "started" ? "Categories__right-gradient" : ""} />
        <span className={sliderStatus === "slided" || sliderStatus === "finished" ? "Categories__left-gradient" : ""} />
        <Container>
          <Slider {...settings}>
            <div onClick={() => ProductsCTX.filterAllProducts()} className="Categories__slider">
              <button className={ProductsCTX.activeCategoryId === 0 ? "Categories__category-item active" : "Categories__category-item"}>
                <span>Të gjitha</span>
              </button>
            </div>
            {menuItems.map((category) => {
              const categoryId = category.connectedObject?.productCategoryId;
              const categoryName = category.label;
              const urlOnActive = category.connectedObject?.categoryHoverImage?.categoryHoverImage?.mediaItemUrl;
              return (
                <div key={`${categoryId}-main-menu-listing`} className="Categories__slider">
                  <button onClick={() => handleCategoryClick(categoryId, categoryName)} className={ProductsCTX.activeCategoryId === categoryId ? "Categories__category-item active" : "Categories__category-item"}>
                    {category.connectedObject && (
                      <div className="item">
                        <img className="icon" src={urlOnActive} alt="" />
                        <img className="iconOnActive" src={urlOnActive} alt="" />
                        <span>{category.label.replace("&amp;", "&")}</span>
                      </div>
                    )}
                  </button>
                </div>
              );
            })}
          </Slider>
        </Container>
        <Container>
          <div className="Categories__sub-cat-container">
            {!props.recipes && subItems.map((item) => (
              <ul key={item.id} id="sub-categories" className={`Categories__sub-categories ${ProductsCTX.activeCategoryId === item.id ? "active" : ""}`}>
                {item.list.map((subItem) => {
                  const slug = subItem.connectedObject?.slug;
                  return (
                    <Link key={slug} to={`/kategoria/${slug}`} className="sub-category-link" onClick={() => handleSubCategoryClick(slug)}>{subItem.label}</Link>
                  );
                })}
              </ul>
            ))}
          </div>
        </Container>
      </div>
    </>
  );
};
